<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>执行控制器</h3>
          </div>
          <div class="div-button">
            <el-button type="primary" class="adduser" @click="handleAdd">添加执行控制器</el-button>

          </div>
        </div>
        <div class="div-step">
          <el-steps :active="3" align-center>
            <el-step title="添加环境模型"></el-step>
            <el-step title="添加环境参数"></el-step>
            <el-step title="环境传感器"></el-step>
            <el-step title="执行控制器"></el-step>
            <!-- <el-step title="阶段控制参数"></el-step> -->
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="环境参数：" prop="paramId">
            <el-select v-model="searchForm.paramId" placeholder="请选择环境参数" clearable @change="handleSearch">
              <el-option v-for="item in paramArray" :key="item.id" :label="item.paramName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型：">
            <el-select v-model="searchForm.deviceType" clearable placeholder="请选择设备类型" @change="handleSearch">
              <el-option v-for="item in deviceTypeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用状态：">
            <el-select v-model="searchForm.status" clearable placeholder="请选择启用状态" @change="handleSearch">
              <el-option label="启动" value="0"></el-option>
              <el-option label="禁用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="环境参数">
              <template slot-scope="scope">
                <p>{{ scope.row.paramType | paramTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备类型">
              <template slot-scope="scope">
                <p>{{ getDeviceTypeName(scope.row.deviceType) }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.switchName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.switchAttrName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="开关开度">
              <template slot-scope="scope">
                <p>{{ scope.row.opening }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="启用状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">启用</p>
                <p v-if="scope.row.status == 1">禁用</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="400">
              <template slot-scope="scope">
                <el-button @click="handlePart(scope.row)" type="text" size="small" v-if="scope.row.controlType == 1">局部控制</el-button>
                <el-button @click="handleStatus(scope.row)" type="text" size="small" v-if="scope.row.status == 1">启用</el-button>
                <el-button @click="handleStatus(scope.row)" type="text" size="small" v-if="scope.row.status == 0">禁用</el-button>
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex;justify-content: space-around;">
          <div></div>
          <div class="pagination-container" style="margin-left: 12rem;margin-top: 3rem;">
            <div class="page"></div>
            <div class="pagination-content-container">
              <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
            </div>
          </div>
          <div style="margin-top: 3.7rem;">
            <el-button type="primary" class="adduser" @click="handlePrev">上一步</el-button>
            <el-button type="primary" class="adduser" @click="handleNext">下一步</el-button>
            <el-button type="primary" class="adduser" @click="handleReturn">返回环境模型</el-button>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="环境参数：" prop="paramId">
                  <el-select v-model="ruleForm.paramId" placeholder="请选择环境参数" clearable @change="paramChange">
                    <el-option v-for="item in paramArray" :key="item.id" :label="item.paramName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备类型：" prop="deviceType">
                  <el-select v-model="ruleForm.deviceType" placeholder="请选择设备类型" clearable>
                    <el-option v-for="item in deviceTypeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备属性：" prop="deviceAttributeId">
                  <el-select v-model="ruleForm.deviceAttributeId" placeholder="请选择设备属性" clearable @change="deviceAttributeChange">
                    <el-option v-for="item in deviceAttributeArray" :key="item.deviceId + ',' + item.attributeId" :label="item.deviceName + '_' + item.attributeName" :value="item.deviceId + ',' + item.attributeId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开关开度：" prop="opening">
                  <el-input-number v-model="ruleForm.opening" placeholder="请输入开关开度" :min="0" :max="100" :precision="0" :step="1" size="small" :disabled="!isOpening"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 批量保存局部控制设备 -->
        <el-dialog title="局部控制设备" :visible.sync="addEditIsDialogPart" :before-close="handleCancelPart" width="800px" center style="z-index: 10000">
          <el-form ref="ruleFormPart" label-width="120px" class="demo-ruleForm">
            <div v-for="(item, index) in ruleFormPart" :key="index">
              <el-row>
                <el-col :span="11">
                  <el-form-item label="设备类型：" prop="deviceType">
                    <el-select v-model="item.deviceType" placeholder="请选择设备类型" clearable>
                      <el-option label="电阀门" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="设备属性：" prop="deviceAttributeId">
                    <el-select v-model="item.deviceAttributeId" placeholder="请选择设备属性" clearable @change="deviceAttributeChangePart(index)">
                      <el-option v-for="item2 in deviceAttributeArray" :key="item2.deviceId + ',' + item2.attributeId" :label="item2.deviceName + '_' + item2.attributeName" :value="item2.deviceId + ',' + item2.attributeId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <a @click="handleDelPart(index)" style="height: 40px; line-height: 40px; margin-left: 30px; color: red">删除</a>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="11">
                  <el-form-item label="开关开度：" prop="opening">
                    <el-input-number v-model="item.opening" placeholder="请输入开关开度" :min="0" :max="100" :precision="0" :step="1" size="small"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="环境传感器：" prop="integerList">
                    <el-select v-model="item.integerList" placeholder="请选择环境传感器" multiple collapse-tags clearable>
                      <el-option v-for="item2 in deviceNumericalArray" :key="item2.id" :label="item2.numericalName + '_' + item2.numericalAttrName" :value="item2.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item style="position: relative">
                  <el-button type="text" @click="handleAddPart" style="position: absolute; margin-left: -20px">+添加局部控制设备</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancelPart">取 消</el-button>
            <el-button type="primary" @click="handleSavePart">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        evnId: "",
        paramId: "",
        deviceType: "",
        status: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        paramId: "",
        deviceType: "",
        switchId: "",
        switchAttrId: "",
        opening: "",
        deviceAttributeId: "",
      },
      rules: {
        // 添加编辑表单规则
        paramId: [
          {
            required: true,
            message: "请选择环境参数",
            trigger: "change",
          },
        ],
        deviceType: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        deviceAttributeId: [
          {
            required: true,
            message: "请选择设备属性",
            trigger: "change",
          },
        ],
        opening: [
          {
            required: true,
            message: "请输入开关开度",
            trigger: "blur",
          },
        ],
      },
      addEditTitle: "添加执行控制器", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      addEditId: "", // 添加编辑id
      ruleFormPart: [], // 局部控制设备表单
      addEditIsDialogPart: false, // 局部控制设备弹窗是否显示
      deviceNumericalArray: [], // 环境传感器数组
      deviceTypeArray: [], // 执行控制器设备类型数组
      deviceAttributeArray: [], // 设备属性数组
      isOpening: false, // 是否可以填写开度，仅仅模拟开关可以填写，其它默认0
      paramArray: [], // 环境参数数组
      paramType: undefined, // 参数类型
    };
  },
  created() {
    this.searchForm.paramId = this.$route.query.paramId;
    this.ruleForm.paramId = this.$route.query.paramId;
    this.searchForm.evnId = this.$route.query.evnId;

    // 获取环境参数列表
    this.getGrowthModelEvnParamAll();

    // 获取环境传感器列表
    this.getDeviceNumericalList();

    // 获取执行控制器设备类型列表
    this.getDeviceTypesList();

    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        evnId: this.$route.query.evnId,
        paramId: "",
        deviceType: "",
        status: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel.getGrowthModelDeviceSwitchList(this.searchForm).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.count;
          this.loading = false;
        }
      });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除时需要检测下该开关是否启用，如果启用需要提醒
          this.$api.growthModel.judge({ id: row.id }).then((res) => {
            if (res.code == 200) {
              if (res.data.status == 1) {
                this.$confirm("所在生长模型正在运行中，是否继续删除？", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    // 删除
                    this.delGrowthModelDeviceSwitch(row);
                  })
                  .catch(() => {
                    this.$message.info("已取消删除");
                  });
              } else {
                // 删除
                this.delGrowthModelDeviceSwitch(row);
              }
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 删除
    delGrowthModelDeviceSwitch(row) {
      this.$api.growthModel.delGrowthModelDeviceSwitch(row.id).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getList();
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑执行控制器";
      this.ruleForm.id = row.id;
      this.ruleForm.modelId = this.paramId;

      // 获取详情
      this.$api.growthModel.getGrowthModelDeviceSwitch({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.deviceAttributeId = res.data.switchId + "," + res.data.switchAttrId;
          this.ruleForm = res.data;

          // 获取大棚设备标签列表
          this.getControlDevices();
        }
      });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加执行控制器";
      this.ruleForm.id = "";
      this.ruleForm.modelId = this.paramId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel.saveGrowthModelDeviceSwitch(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.handleCancel();
              this.handleSearch();
            }
          });
        }
      });
    },
    // 启用禁用
    handleStatus(row) {
      // 启用禁用时需要检测下该开关是否启用，如果启用需要提醒
      this.$api.growthModel.judge({ id: row.id }).then((res) => {
        if (res.code == 200) {
          if (res.data.status == 1) {
            this.$confirm("所在生长模型正在运行中，是否继续" + (row.status == 0 ? "禁用" : "启用") + "？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                // 启用禁用
                this.openOrCloseGrowthModelDeviceSwitch(row);
              })
              .catch(() => {
                this.$message.info("已取消" + (row.status == 0 ? "禁用" : "启用"));
              });
          } else {
            // 启用禁用
            this.openOrCloseGrowthModelDeviceSwitch(row);
          }
        }
      });
    },
    // 启用禁用
    openOrCloseGrowthModelDeviceSwitch(row) {
      this.$api.growthModel.openOrCloseGrowthModelDeviceSwitch({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getList();
        }
      });
    },
    // 局部控制设备
    handlePart(row) {
      this.addEditIsDialogPart = true;
      this.addEditId = row.id;
      this.paramType = row.paramType;
      this.$api.growthModel.getGrowthModelDeviceSwitchSecondAll({ deviceSwitchId: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((val) => {
            val.deviceType = val.deviceType != undefined ? val.deviceType.toString() : "";
            if (val.switchId != undefined && val.switchAttrId != undefined) {
              val.deviceAttributeId = val.switchId + "," + val.switchAttrId;
            }
            val.integerList = val.deviceNumericalIds != undefined ? val.deviceNumericalIds : [];
          });
          this.ruleFormPart = res.data;
        }
      });

      // 获取大棚设备标签列表
      this.getControlDevices();
    },
    // 添加局部控制
    handleAddPart() {
      this.ruleFormPart.push({
        id: "",
        deviceSwitchId: this.addEditId,
        deviceType: "",
        deviceAttributeId: "",
        switchId: "",
        switchAttrId: "",
        opening: "0",
        integerList: [],
      });
    },
    // 删除局部控制
    handleDelPart(index) {
      this.ruleFormPart.splice(index, 1);
    },
    // 关闭局部控制
    handleCancelPart() {
      this.ruleFormPart = [];
      this.addEditIsDialogPart = false;
    },
    // 保存局部控制
    handleSavePart() {
      let flag = false;
      this.ruleFormPart.forEach((val) => {
        if (!val.deviceType || val.deviceType === "") {
          flag = true;
          return;
        }
        if (!val.deviceAttributeId || val.deviceAttributeId === "") {
          flag = true;
          return;
        }
        if (val.opening === "") {
          flag = true;
          return;
        }
        if (!val.integerList || val.integerList.length == 0) {
          flag = true;
          return;
        }
      });

      if (flag) {
        this.$message({
          type: "error",
          message: "请完善局部控制设备信息",
        });
        return;
      }

      // 保存
      this.$api.growthModel
        .saveModelDeviceSwitchSecondList({
          deviceSwitchId: this.addEditId,
          saveModelDeviceSwitchSeconds: this.ruleFormPart,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.handleCancelPart();
          }
        });
    },
    // 获取大棚设备标签列表
    getControlDevices() {
      this.$api.growthModel
        .getControlDevices({
          type: 3,
          deviceSign: this.paramType,
          groupId: this.$route.query.groupId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceAttributeArray = res.data;
          }
        });
    },
    // 设备属性下拉切换
    deviceAttributeChange() {
      if (this.ruleForm.deviceAttributeId) {
        let arr = this.ruleForm.deviceAttributeId.split(",");
        this.ruleForm.switchId = arr[0];
        this.ruleForm.switchAttrId = arr[1];
      } else {
        this.ruleForm.switchId = "";
        this.ruleForm.switchAttrId = "";
      }
    },
    // 设备属性下拉切换-局部控制设备
    deviceAttributeChangePart(index) {
      if (this.ruleFormPart[index].deviceAttributeId) {
        let arr = this.ruleFormPart[index].deviceAttributeId.split(",");
        this.ruleFormPart[index].switchId = arr[0];
        this.ruleFormPart[index].switchAttrId = arr[1];
      } else {
        this.ruleFormPart[index].switchId = "";
        this.ruleFormPart[index].switchAttrId = "";
      }
    },
    // 获取环境参数列表
    getGrowthModelEvnParamAll() {
      this.$api.growthModel.getGrowthModelEvnParamAll({ evnId: this.$route.query.evnId }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((val) => {
            val.paramName = this.$filters.paramTypeName(val.paramType);
          });
          this.paramArray = res.data;
        }
      });
    },
    // 获取环境传感器列表
    getDeviceNumericalList() {
      this.$api.growthModel
        .getGrowthModelDeviceNumericalAll({
          paramId: this.$route.query.paramId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceNumericalArray = res.data;
          }
        });
    },
    // 获取执行控制器设备类型列表
    getDeviceTypesList() {
      this.$api.growthModel
        .getDeviceTypes({
          paramId: this.$route.query.paramId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceTypeArray = res.data;
          }
        });
    },
    // 获取执行控制器设备类型表格数据
    getDeviceTypeName(deviceType) {
      let deviceTypeName = "";
      this.deviceTypeArray.map((val) => {
        if (deviceType == val.id) {
          deviceTypeName = val.name;
          return;
        }
      });

      return deviceTypeName;
    },
    // 环境参数下拉切换
    paramChange() {
      this.ruleForm.deviceAttributeId = [];
      this.ruleForm.numericalId = "";
      this.ruleForm.numericalAttrId = "";
      this.deviceAttributeArray = [];

      if (!this.ruleForm.paramId || this.ruleForm.paramId == "") {
        return;
      }

      this.paramArray.forEach((val) => {
        if (val.id == Number(this.ruleForm.paramId)) {
          this.paramType = val.paramType;
          return;
        }
      });

      // 获取大棚设备标签列表
      this.getControlDevices();
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: "second",
        },
      });
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `addDeviceNumerical`,
        query: {
          evnId: this.$route.query.evnId,
          groupId: this.$route.query.groupId,
        },
      });
    },
    // 下一步
    handleNext() {
      this.$router.push({
        name: `addStageControl`,
        query: {
          evnId: this.$route.query.evnId,
          groupId: this.$route.query.groupId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 0px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>
